import { MDSIconKind } from "@/mds/components/icon";
import { ButtonProps } from "react-aria-components";

export enum MDSCardSlotName {
  RightAddon = "rightAddon",
  Content = "content",
}

export interface IMDSCardProps extends ButtonProps {
  /**
   * Icon kind to display
   */
  mdsIcon?: MDSIconKind | (() => React.ReactNode);

  /**
   * Card title
   */
  title?: string;

  /**
   * Card description text
   */
  description?: string;

  className?: string;

  children: React.ReactNode;
}
